import React from 'react'
import { Link } from 'react-router'

const Entry = ({children}) => (
  <div>
    <div className='login-banner'>
      <Link to='/login'>
        <img className='logo' src={require('../images/logo.svg')} alt='logo' />
      </Link>
    </div>
    {children}
  </div>
)

export default Entry



// WEBPACK FOOTER //
// ./src/components/entry.js